import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { handlerErrorV2 } from "../../utils/errors.jsx";

import { toggleLoadingAssessmentCurriculum, updateAssessmentCurriculum, updateErrorAssessmentCurriculum } from "../../store/actions/assessment.actions.js";
import { getTenantCurriculum } from "../../services/tenant/tenant.service.js";

const useTenant = () => {
  const dispatch = useDispatch();

  const onLoadAssessmentCurriculum = useCallback(async (studentId) => {
    dispatch(toggleLoadingAssessmentCurriculum(true));
    try {
      const response = await getTenantCurriculum({ studentId });
      if (!response.data && response.error) {
        dispatch(
          updateErrorAssessmentCurriculum(
            response.error.message || "An error ocurred"
          )
        );
      } else {
        dispatch(updateAssessmentCurriculum(response.data));
      }
    } catch (error) {
      dispatch(updateErrorAssessmentCurriculum(handlerErrorV2(error)));
    } finally {
      dispatch(toggleLoadingAssessmentCurriculum(false));
    }
  }, []);

  return {
    onLoadAssessmentCurriculum
  }
};

export default useTenant;